export const splashScreenStyles = {
	root: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: 'calc(100vh - 16px)',
		backgroundColor: 'background.default'
	},
	logo: {
		width: '100%',
		height: 42
	}
};
